import { configureStore } from '@reduxjs/toolkit';
import { loadStripe } from '@stripe/stripe-js';
import cartReducer from '../slices/cart';
import shippingMethodsReducer from '../slices/shippingMethods';
import aovReducer from '../slices/aovs';
import cartEvents from './middlewares/cart-events';
import cartChangesToDrupal from './middlewares/cartChangesToDrupal';
import orderReducer from '../slices/orders';
import paymentsReducer from '../slices/payments';
import billingAddressReducer from '../slices/billingAddress';
import shippingAddressReducer from '../slices/shippingAddress';
import pdpReducer from '../slices/pdp';
import accountsReducer from '../slices/accounts';
import bundlePdpReducer from '../slices/bundlePdp';
import tealiumEvents from './middlewares/tealium-events/tealium-events';
import recentAddToCart from './middlewares/recent-add-to-cart';

const store = configureStore({
  reducer: {
    cart: cartReducer,
    shippingMethods: shippingMethodsReducer,
    aov: aovReducer,
    order: orderReducer,
    payments: paymentsReducer,
    billingAddress: billingAddressReducer,
    shippingAddress: shippingAddressReducer,
    pdp: pdpReducer,
    accounts: accountsReducer,
    bundlePdp: bundlePdpReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(cartEvents)
      .concat(tealiumEvents)
      .concat(cartChangesToDrupal)
      .concat(recentAddToCart),
});

window.readOnlyPurpleStore = store;

// Load Stripe JS on the page for Radar.
loadStripe(process.env.STRIPE_CLIENT_API_KEY);

export default store;
